import { useIsActiveCQTPortal, useIsUngatedForCpqUpgrades } from '../../auth/gates';
import { useIsPaidPortal } from '../../products/useIsPaidPortal';
export const CPQ_COHORT = {
  NONE: 'NONE',
  FREE_PORTAL_NOT_PUBLISHED_QUOTES: 'FREE_PORTAL_NOT_PUBLISHED_QUOTES',
  FREE_PORTAL_PUBLISHED_QUOTES: 'FREE_PORTAL_PUBLISHED_QUOTES',
  PAID_PORTAL_PUBLISHED_QUOTES: 'PAID_PORTAL_PUBLISHED_QUOTES',
  PAID_PORTAL_NOT_PUBLISHED_QUOTES: 'PAID_PORTAL_UNPUBLISHED_QUOTES'
};
const useGetCPQCohort = () => {
  const [isPaidPortal, isPaidPortalLoading] = useIsPaidPortal();
  const isUngatedForCpqUpgrades = useIsUngatedForCpqUpgrades();
  const isActiveCQTPortal = useIsActiveCQTPortal();
  if (!isUngatedForCpqUpgrades || isPaidPortalLoading) {
    return CPQ_COHORT.NONE;
  }
  if (!isPaidPortal) {
    return isActiveCQTPortal ? CPQ_COHORT.FREE_PORTAL_PUBLISHED_QUOTES : CPQ_COHORT.FREE_PORTAL_NOT_PUBLISHED_QUOTES;
  }
  if (isActiveCQTPortal) {
    return CPQ_COHORT.PAID_PORTAL_PUBLISHED_QUOTES;
  }
  return CPQ_COHORT.PAID_PORTAL_NOT_PUBLISHED_QUOTES;
};
export default useGetCPQCohort;